module.exports = __webpack_public_path__ + "static/bar2-f800078635f3d4360c7942c82c7cd7b7.png";